const postSites = {
  toastr: 'Sitio agregado',
  toastr1: ' fue agregado con éxito',
  toastrError: 'Sitio ya registrado',
  toastrError1: 'Ingrese otro nombre'
};

export default postSites;
